module.exports = __webpack_public_path__ + "img/icon1.d702a4e8.png";